import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar, MatLegacySnackBarConfig as MatSnackBarConfig } from '@angular/material/legacy-snack-bar';

@Injectable()
export class SnackBarService {
  private snackBarConfig: MatSnackBarConfig = new MatSnackBarConfig();
  static customAction: string = 'CLOSE';

  constructor(private snackBar: MatSnackBar) {
    this.snackBarConfig.verticalPosition = 'top';
    this.snackBarConfig.horizontalPosition = 'right';
    this.snackBarConfig.duration = 5000;
  }

  public open(message: string, success: boolean) {
    var config = this.snackBarConfig;
    if (success) {
      config.panelClass = ['success'];
    } else {
      config.panelClass = ['error'];
    }
    this.snackBar.open(message, SnackBarService.customAction, config);
  }
}
